import Vue from "vue";

// Vue configuration
import "../global_config";

// Main component
import App from "./App.vue";

new Vue({
  render: h => h(App)
}).$mount("#app");
